import { useTranslation } from 'react-i18next';

interface SimilarityBadgeProps {
  similarity: number | null | undefined;
}

/**
 * Displays a similarity score badge.
 * - similarity >= 0.3: "유사도 XX%" chip
 * - similarity present but < 0.3: "부분 일치" (ILIKE-only match)
 * - null/undefined: "-"
 */
export function SimilarityBadge({ similarity }: SimilarityBadgeProps) {
  const { t } = useTranslation();

  if (similarity === null || similarity === undefined) {
    return <span style={{ color: 'var(--color-text-muted)' }}>-</span>;
  }

  const percent = Math.round(similarity * 100);

  if (similarity >= 0.3) {
    const hue = Math.round(120 * similarity); // green at 1.0, red at 0.0
    return (
      <span
        aria-label={t('terminologyManagement.similarity.exact', { percent })}
        style={{
          display: 'inline-block',
          padding: '0 var(--spacing-2)',
          borderRadius: 'var(--radius-full)',
          background: `hsl(${hue}, 60%, 90%)`,
          color: `hsl(${hue}, 60%, 30%)`,
          fontSize: 'var(--font-size-xs)',
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        {percent}%
      </span>
    );
  }

  return (
    <span
      aria-label={t('terminologyManagement.similarity.partial')}
      style={{
        display: 'inline-block',
        padding: '0 var(--spacing-2)',
        borderRadius: 'var(--radius-full)',
        background: 'var(--color-surface-muted)',
        color: 'var(--color-text-secondary)',
        fontSize: 'var(--font-size-xs)',
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {t('terminologyManagement.similarity.partial')}
    </span>
  );
}
